// Turns arbitrary text into a filename-safe slug, e.g. 'Acme Corp.' -> 'acme-corp'
const slug = (name) => (name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export default slug;
